import { createRoot } from 'react-dom/client';

import { Root } from './app';

const rootNode = document.querySelector('#root')!;
const root = createRoot(rootNode);

root.render(<Root />);
